// extracted by mini-css-extract-plugin
export var productImage = "_n7-1";
export var viewLink = "_n7-2";
export var wishlistItem = "_n7-0";